import { facetEngagementAdapter  } from './facet';
import { bannerEngagementAdapter } from './banner';
import { modelToggleEngagementAdapter } from './model-toggle';

export const engagementsString = ({ queryString, facetData }) => {
  return [
    facetEngagementAdapter(facetData),
    bannerEngagementAdapter(queryString),
    modelToggleEngagementAdapter(),
  ].filter(engagement => !!engagement)
   .join(' | ');
}
